// domGroupWeekly.tsx
import { CalendarGroupingEnum, CalendarSpanEnum } from "src/types";
import moment from "moment";

export const domGroupWeekly = (
  instanceKey: string, 
  span: CalendarSpanEnum,
  grouping: CalendarGroupingEnum, 
  currentDate: Date,
  events: any[], 
  isMobile: boolean,

) => {
  let timerId: number | undefined;
  let resizeObserver: ResizeObserver | undefined;
  let scrollHandler: ((event: Event) => void) | undefined;
  let windowResizeHandler: (() => void) | undefined; 

  if (grouping !== "individual" && span === "week") {
   
      timerId = window.setTimeout(() => {
   
        const allCalendarElements = document.querySelector('#allCalendarElements');
        if (!allCalendarElements) return;

        const allCalendarElements2 = document.querySelectorAll<HTMLDivElement>('div[id^="allCalendarElements2-"]');
        if (!allCalendarElements2.length) return;

        // Remove any existing sticky header to avoid duplicates
        const existingStickyHeader = allCalendarElements.querySelector('.sticky-week-header-container');
        if (existingStickyHeader) {
          existingStickyHeader.remove();
        }

        // Find the first calendar's week header to use as reference
        const firstCalendar = allCalendarElements2[0];
        const firstWeekHeader = firstCalendar.querySelector('.rbc-row.rbc-month-header');
        if (!firstWeekHeader) return;

        // Get the date cells from the first week to determine the dates
        const firstWeekRow = firstCalendar.querySelector('.rbc-month-view .rbc-month-row.current-week') || 
                            firstCalendar.querySelector('.rbc-month-view .rbc-month-row');
        const dateCells = firstWeekRow?.querySelectorAll('.rbc-date-cell');
        
        // Create array of dates for the week
        const weekDates: Date[] = [];
        if (dateCells && dateCells.length > 0) {
          // Get the start of the week from the current date
          const weekStart = moment(currentDate).startOf('week');
          
          // Generate 7 days starting from the week start
          for (let i = 0; i < 7; i++) {
            const dateObj = moment(weekStart).add(i, 'days').toDate();
            weekDates.push(dateObj);
          }
        }

        // Clone the header structure
        const stickyHeaderContainer = document.createElement('div');
        stickyHeaderContainer.className = 'sticky-week-header-container';
        stickyHeaderContainer.style.cssText = `
          position: sticky;
          top: 0;
          z-index: 20;
          display: flex;
          flex-direction: row;
          width: 100%;
          height: 25px;
          min-height: 25px;
          margin-bottom: -25px;
          background-color: #e4e4e4;
        `;

        // Create the name cell space
        const nameCellSpace = document.createElement('div');
        nameCellSpace.style.cssText = `
          width: ${isMobile ? '100px' : '150px'};
          min-width: ${isMobile ? '100px' : '150px'};
          flex-shrink: 0;
          background-color: #e4e4e4;
          position: sticky;
          left: 0;
          z-index: 21;
        `;
        stickyHeaderContainer.appendChild(nameCellSpace);

        // Create container for the header cells
        const headerCellsContainer = document.createElement('div');
        headerCellsContainer.style.cssText = `
          display: flex;
          flex: 1;
          overflow: visible;
          min-width: 1000px;
        `;

        // Create new header row with custom week date headers
        const customHeaderRow = document.createElement('div');
        customHeaderRow.className = 'rbc-row rbc-month-header';
        customHeaderRow.style.cssText = `
          display: flex;
          flex: 1;
          border: none;
          margin: 0;
          padding: 0;
          min-width: 1000px;
          background-color: #e4e4e4;
        `;

        // Get the original header cells to maintain the same flex/width properties
        const originalHeaderCells = firstWeekHeader.querySelectorAll('.rbc-header');
        
        // Create custom header cells with week format
        originalHeaderCells.forEach((originalCell, index) => {
          const headerCell = document.createElement('div');
          headerCell.className = 'rbc-header';
          
          // Copy computed styles from original
          const computedStyle = window.getComputedStyle(originalCell);
          headerCell.style.cssText = `
            background-color: #e4e4e4 !important;
            font-weight: normal;
            text-align: center;
            padding: 0;
            display: flex;
            height: 25px;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            border-right: 1px solid white;
            border-left: 1px solid #bbb;
            flex: ${computedStyle.flex};
            min-width: ${computedStyle.minWidth};
            width: ${computedStyle.width};
          `;

          // Create inner container for the date header content
          const headerContent = document.createElement('div');
          headerContent.style.cssText = `
            position: relative;
            min-height: 30px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 1;
            flex-basis: 100%;
            font-weight: bold;
          `;

          // Add the formatted date label if we have a corresponding date
          if (weekDates[index]) {
            const date = weekDates[index];
            const formattedLabel = `${moment(date).format('M/D')} (${moment(date).format('dd')})`;
            
            const labelSpan = document.createElement('span');
            labelSpan.textContent = formattedLabel;
            headerContent.appendChild(labelSpan);

            // Add the plus button
            const plusButton = document.createElement('button');
            plusButton.onclick = (e) => {
              e.stopPropagation();
              // Trigger the add event - you'll need to implement this
              console.log("Add clicked for date:", date);
              // You can dispatch a custom event here that ScheduleCalendar can listen for
              const customEvent = new CustomEvent('groupWeekAddClick', {
                detail: { date: date, instanceKey: instanceKey },
                bubbles: true
              });
              plusButton.dispatchEvent(customEvent);
            };
            plusButton.style.cssText = `
              position: absolute;
              left: 5px;
              top: 7px;
              z-index: 10;
              background: transparent;
              color: #ff6a0c;
              border: none;
              border-radius: 50%;
              width: 18px;
              height: 18px;
              font-size: 24px;
              font-weight: bold;
              line-height: 14px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              pointer-events: auto;
            `;
            plusButton.textContent = '+';
            headerContent.appendChild(plusButton);
          }

          headerCell.appendChild(headerContent);
          customHeaderRow.appendChild(headerCell);
        });

        headerCellsContainer.appendChild(customHeaderRow);
        stickyHeaderContainer.appendChild(headerCellsContainer);

        // Insert the sticky header
        allCalendarElements.insertBefore(stickyHeaderContainer, allCalendarElements.firstChild);

        // Push down the first calendar element
        const firstCalendarElement = document.querySelector('#allCalendarElements2-1');
        if (firstCalendarElement) {
          (firstCalendarElement as HTMLElement).style.marginTop = '25px';
        }

        // Hide all the original headers
        allCalendarElements2.forEach((calendar) => {
          const originalHeader = calendar.querySelector('.rbc-row.rbc-month-header');
          if (originalHeader) {
            (originalHeader as HTMLElement).style.visibility = 'hidden';
            (originalHeader as HTMLElement).style.height = '0';
            (originalHeader as HTMLElement).style.minHeight = '0';
            (originalHeader as HTMLElement).style.overflow = 'hidden';
          }
        });

        // Function to sync the header width
        const syncHeaderWidth = () => {
          const firstCalendarContent = firstCalendar.querySelector('.rbc-month-view');
          const firstCalendarHeaders = firstCalendar.querySelectorAll('.rbc-header');
          
          if (firstCalendarContent && headerCellsContainer && firstCalendarHeaders.length > 0) {
            const contentWidth = (firstCalendarContent as HTMLElement).scrollWidth;
            headerCellsContainer.style.width = `${contentWidth}px`;
            
            const customHeaders = headerCellsContainer.querySelectorAll('.rbc-header');
            firstCalendarHeaders.forEach((originalHeader, index) => {
              if (customHeaders[index]) {
                const originalComputedStyle = window.getComputedStyle(originalHeader);
                (customHeaders[index] as HTMLElement).style.width = originalComputedStyle.width;
                (customHeaders[index] as HTMLElement).style.minWidth = originalComputedStyle.minWidth;
                (customHeaders[index] as HTMLElement).style.maxWidth = originalComputedStyle.maxWidth;
                (customHeaders[index] as HTMLElement).style.flex = originalComputedStyle.flex;
              }
            });
          }
        };

        // Initial sync
        syncHeaderWidth();

        // Set up resize observer
        if (window.ResizeObserver) {
          resizeObserver = new ResizeObserver(() => {
            syncHeaderWidth();
          });
          
          const firstCalendarContent = firstCalendar.querySelector('.rbc-month-view');
          if (firstCalendarContent) {
            resizeObserver.observe(firstCalendarContent);
          }
        }

        // Set up scroll handler
        scrollHandler = () => {
          if (allCalendarElements instanceof HTMLElement && headerCellsContainer) {
            const scrollLeft = allCalendarElements.scrollLeft;
            stickyHeaderContainer.style.marginLeft = `-${scrollLeft}px`;
            nameCellSpace.style.marginLeft = `${scrollLeft}px`;
          }
        };

        allCalendarElements.addEventListener('scroll', scrollHandler);

        // Handle window resize
        const handleWindowResize = () => {
          setTimeout(syncHeaderWidth, 100);
        };
        window.addEventListener('resize', handleWindowResize);

        // Store cleanup functions
        (stickyHeaderContainer as any)._cleanup = () => {
          if (windowResizeHandler) {
            window.removeEventListener('resize', windowResizeHandler);
          }
          if (scrollHandler && allCalendarElements) {
            allCalendarElements.removeEventListener('scroll', scrollHandler);
          }
          if (resizeObserver) {
            resizeObserver.disconnect();
          }
        };

      }, 50);
    
  

  // Return the cleanup function
  return () => {
    if (timerId) clearTimeout(timerId);

    // Clean up the window resize handler if it exists
    if (windowResizeHandler) {
      window.removeEventListener('resize', windowResizeHandler);
    }

    // Clean up scroll handler if it exists
    if (scrollHandler) {
      const allCalendarElements = document.querySelector('#allCalendarElements');
      if (allCalendarElements) {
        allCalendarElements.removeEventListener('scroll', scrollHandler);
      }
    }

    // Clean up resize observer if it exists
    if (resizeObserver) {
      resizeObserver.disconnect();
    }

    const allCalendarElements = document.querySelector('#allCalendarElements');
    if (allCalendarElements) {
      const stickyHeader = allCalendarElements.querySelector('.sticky-week-header-container');
      if (stickyHeader) {
        if (typeof (stickyHeader as any)._cleanup === 'function') {
          (stickyHeader as any)._cleanup();
        }
        stickyHeader.remove();
      }
    }

    const allCalendarElements2 = document.querySelectorAll<HTMLDivElement>('div[id^="allCalendarElements2-"]');
    allCalendarElements2.forEach((calendar) => {
      const originalHeader = calendar.querySelector('.rbc-row.rbc-month-header');
      if (originalHeader) {
        (originalHeader as HTMLElement).style.visibility = '';
        (originalHeader as HTMLElement).style.height = '';
        (originalHeader as HTMLElement).style.minHeight = '';
        (originalHeader as HTMLElement).style.overflow = '';
      }
    });

    const firstCalendarElement = document.querySelector('#allCalendarElements2-1');
    if (firstCalendarElement) {
      (firstCalendarElement as HTMLElement).style.marginTop = '';
    }

    }; // return statement
  }

  return undefined;
};